import request from "../utils/request";

// pkgInfo/queryDayAnalysisList POST
export function queryDayAnalysisList(data) {
  return request({
    url: '/pkgInfo/queryDayAnalysisList',
    method: 'post',
    data: data
  })
}

// express/noticeCourierV2 POST
export function noticeCourierV2(data) {
  return request({
    url: '/express/noticeCourierV2',
    method: 'post',
    data: data
  })
}

// pickupInformation/queryPickupAnalysis
export function queryPickupAnalysis(data) {
  return request({
    url: '/pickupInformation/queryPickupAnalysis',
    method: 'post',
    data: data
  })
}

// express/cancleNoticeCourier get
export function cancleNoticeCourier(params) {
  return request({
    url: '/express/cancleNoticeCourier',
    method: 'get',
    params: params
  })
}

// pickupInformation/exportPickupRecord post
export function exportPickupRecord(data) {
  return request({
    url: '/pickupInformation/exportPickupRecord',
    method: 'post',
    data: data
  })
}


// agentUserAddress/getAddressAgentList
export function getAddressAgentList(data) {
  return request({
    url: '/agentUserAddress/getAddressAgentList',
    method: 'post',
    data: data
  })
}
